export default __webpack_public_path__ + "static/media/Methodology-image.af8b12df.PNG";